"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/opt/build/repo/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _webgltextureLoader = require("webgltexture-loader");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CanvasTextureLoader =
/*#__PURE__*/
function (_webgltextureLoader$W) {
  _inherits(CanvasTextureLoader, _webgltextureLoader$W);

  function CanvasTextureLoader() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CanvasTextureLoader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CanvasTextureLoader)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "disposes", {});

    return _this;
  }

  _createClass(CanvasTextureLoader, [{
    key: "canLoad",
    value: function canLoad(input) {
      return input instanceof HTMLCanvasElement;
    }
  }, {
    key: "inputHash",
    value: function inputHash(input) {
      return input;
    }
  }, {
    key: "getNoCache",
    value: function getNoCache(input) {
      var gl = this.gl;
      var width = input.width,
          height = input.height;
      var texture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, input);
      return {
        texture: texture,
        width: width,
        height: height
      };
    }
  }, {
    key: "update",
    value: function update(input) {
      var gl = this.gl;

      var _this$get = this.get(input),
          texture = _this$get.texture;

      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, input);
    }
  }]);

  return CanvasTextureLoader;
}(_webgltextureLoader.WebGLTextureLoaderSyncHashCache);

_webgltextureLoader.globalRegistry.add(CanvasTextureLoader);

var _default = CanvasTextureLoader;
exports["default"] = _default;